import React, { useState, useEffect, useRef } from "react";
import { Wheel } from "react-custom-roulette";
import { useDispatch, useSelector } from "react-redux";
import { fetchAPI } from "../service/Encrtyption";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "../modal";
import { useTranslation } from "react-i18next";
import spinBg from "../../../src/assets/images/spin-bg.png";
import GiftedImg from "../../../src/assets/images/GiftedImg.jpg";
// import congratulationsSound from "../../../src/assets/images/crowd_sound.mp3";
import Glitter from "../../../src/assets/images/glitter.gif";
import wired_flat from "../../../src/assets/images/wired-flat.gif";
import { Loader } from "../loader";
import { giftImageUrlFun, spinStatus, setSecondaryMessageAction } from "../auth/redux/store";
import ReactGA from 'react-ga4';
import Close from "../../../src/assets/images/cross.png";
import html2canvas from 'html2canvas';

const CustomRoulette = ({ wheelItems, spinInnerImage, stopPrizeNumber, closeModal }) => {
  const [mustSpin, setMustSpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [congratsImageUrl, setCongratsImageUrl] = useState("");
  const [primaryRewardMsg, setprimaryRewardMsg] = useState("");
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [GiftImageURL, setGiftImageURL] = useState('');
  const [secondaryMessage, setSecondaryMessage] = useState('');
  const [couponCodeList, setCouponCodeList] = useState('');
  const [rewardWoncheck, setRewardWoncheck] = useState('');
  const [shareMsg, setShareMsg] = useState('');
  const audioRef1 = useRef(null);

  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [stopPrizeNumberNew, setStopPrizeNumberNew] = useState(stopPrizeNumber);
  const spinValue = useSelector((state) => state?.spinValue);
  const genunityData = useSelector((state) => state?.genunityData);
  const cropData = useSelector((state) => state?.cropData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outerBorderColor = '#3D1D50';
  const outerBorderWidth = 27;
  const innerBorderColor = '#F16922';
  const innerBorderWidth = 15;
  const innerRadius = 0;
  // const radiusLineColor = '#44A7EB';
  const radiusLineWidth = 0;
  const currentLanguage =lang;
  // console.log("currentLanguage+" + currentLanguage);
  const data = (wheelItems ?? []).map((item, index) => {
    if (item?.imageUrl && item?.imageUrl?.trim() !== "") {
      return {
        option: "",
        style: { backgroundColor: item?.colorCode },
        image: {
          uri: item?.imageUrl,
          offsetX: 10,
          offsetY: 160,
          sizeMultiplier: 0.9,
          landscape: false,
        },
        index: index, // Pass the index of the item
      };
    } else {
      // Render text (item name) if imageUrl is empty
      return {
        option: item?.name, // Use item.name directly as the option
        style: {
          backgroundColor: item?.colorCode, // Background color from the item
          fontSize: 20,                    // Font size
          fontWeight: "bold",               // Bold text
          textAlign: "center",              // Center align text
          color: "#fff",                    // White text color
          maxWidth: "100%",                 // Adjust max width as needed
          wordWrap: "break-word",           // Allow long words to break
          overflowWrap: "break-word",       // Alternative for word wrapping
          whiteSpace: "normal",             // Ensure text wraps within the container
          display: "-webkit-box",           // Enable multi-line truncation
          WebkitLineClamp: 2,               // Limit to 2 lines
          WebkitBoxOrient: "vertical",      // Required for Webkit truncation
          overflow: "hidden",               // Hide overflow after 2 lines
        },
        index: index, // Pass the index of the item
      };
    }
  });


  const mobileNumber = sessionStorage.getItem('mbn');

  // Define handleSpin function to be called when necessary
  const handleSpin = async () => {
    // debugger;
    setLoading(true);

    ReactGA.event({
      category: 'User Spin Wheel Clicked',
      action: 'CLK_SPINWHEEL_BTN'
    });

    const updatedJsonData = {
      ...genunityData,
      destinationURL: "/updateStrongarmSpinStatus",
      secondaryRewardMsg: "",
      // rewardPoints: genunityData.rewardPoints,
      // cashRewards: genunityData.cashRewards,
      rewardPoints: "",
      cashRewards: "",
      selectedCropName: cropData
    };
    // debugger; 
    console.log(JSON.stringify(updatedJsonData) + "updatedJsonData");
    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        updatedJsonData,
        {
          appLangCode: currentLanguage,
          mobileNumber: mobileNumber,
          deviceType: "WEB",
          deviceId: "WEB"
        }
      );
      const jsonReposneData = JSON.parse(responseData);
      console.log(JSON.stringify(responseData) + "SPIN DATA");
      if (jsonReposneData.statusCode === "200") {
        const imageUrl = jsonReposneData.congratsImageUrl;
        const apiPrimaryRewardMsg = jsonReposneData.primaryRewardMsg;
        setprimaryRewardMsg(apiPrimaryRewardMsg);
        setCongratsImageUrl(imageUrl);
        setMustSpin(spinValue);
        const announcementMessage = jsonReposneData.secondaryRewardMsg;
        const ApicouponCode = jsonReposneData.couponCode;
        const apiRewardWon = jsonReposneData.rewardWon;
        const apishareMsg = jsonReposneData.shareMsg;
        setSecondaryMessage(announcementMessage);
        setCouponCodeList(ApicouponCode);
        setRewardWoncheck(apiRewardWon);
        setShareMsg(apishareMsg);
        dispatch(setSecondaryMessageAction(announcementMessage));
        console.log(ApicouponCode + "couponCodeList");

        if (jsonReposneData.congratsImageUrl != '') {
          dispatch(giftImageUrlFun(jsonReposneData.congratsImageUrl))
        }
        // const selectedItem = jsonReposneData.wheelStoppingIndex - 1;
        // setStopPrizeNumberNew(selectedItem); // Set the stopPrizeNumber based on the item's id
        const wheelStoppingIndex = parseInt(jsonReposneData.wheelStoppingIndex, 10);

        if (!isNaN(wheelStoppingIndex) && wheelStoppingIndex !== undefined && wheelStoppingIndex > 0) {
          const selectedItem = wheelStoppingIndex - 1; // This now ensures selectedItem is never -1
          //  console.log("Selected Item:", selectedItem);

          if (selectedItem >= 0 && selectedItem < wheelItems.length) {
            setStopPrizeNumberNew(selectedItem);
          } else {
            console.error("Selected Item is out of valid range:", selectedItem);
            // Handle out-of-range scenario
          }
        } else {
          setStopPrizeNumberNew(1);
          console.error("Invalid or zero wheelStoppingIndex received:", wheelStoppingIndex);
          // Handle invalid or zero index scenario
        }
      }
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };
  // Call handleSpin when mustSpin state changes
  useEffect(() => {
    if (spinValue) {
      handleSpin();
    }
  }, [spinValue]);

  const handlePlayAudio = () => {
    if (audioRef1.current) {
      console.log('Audio source:', audioRef1.current.src);
      audioRef1.current.play().catch((error) => {
        console.error('Error playing audio:', error);
      });
      // setTimeout(() => {
      //   if (audioRef1.current) {
      //     audioRef1.current.pause();
      //     audioRef1.current.currentTime = 0;
      //   }
      // }, 7000);
      // setHasInteracted(true);
    } else {
      console.log('Audio ref is not set');
    }
  };

  const handleSpinningStop = () => {
    dispatch(spinStatus(false));
    handlePlayAudio();
    const style = document.createElement('style');
    style.textContent = `
    #spinModal {
      visibility: hidden;
    }
  `;
    document.head.appendChild(style);
    setRewardUpdateModal(true);
  };

  const handleCloseModal = () => {
    closeModal();
    audioRef1.current?.pause();
  };

  const handleOk = () => {
    closeModal();
    audioRef1.current?.pause();
  };

  // const handleShare = () => {
  //   closeModal();
  //   audioRef1.current.pause();

  // };


  const fallbackToWhatsApp = (message) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
  };

  const captureAndShare = async () => {
    localStorage.setItem("fromExternalRedirect", "true");

    const fileUrl = `${process.env.REACT_APP_URL_SURVEY}${t("language")}?productScanShared=true`;
    let combinedText = shareMsg ? shareMsg.replace(/<br\s*\/?>/gi, '\n') : "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.";
    const fallbackMessage = `${combinedText}`; 

    try {
      const canUseWebShare = !!navigator.share;

      if (canUseWebShare) {
        await navigator.share({
          title: combinedText,
          text: fallbackMessage
          // Removed: url: fileUrl
        });
      } else {
        fallbackToWhatsApp(fallbackMessage);
      }
    } catch (error) {
      fallbackToWhatsApp(fallbackMessage);
    }
  };


  return (
    <>
      {loading && <Loader />}

      {/* <audio ref={audioRef1} onLoadedData={() => console.log('Audio is ready to play')}>
        <source src={congratulationsSound} type="audio/mpeg" />
      </audio> */}

      <div style={{
        textAlign: "center",
        position: 'relative',
        backgroundImage: `url(${spinBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '24px 0px'
      }}>

        {data.length > 0 && (
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={stopPrizeNumberNew}
          data={data}
          outerBorderColor={""}
          outerBorderWidth={outerBorderWidth}
          innerRadius={innerRadius}
          innerBorderColor={innerBorderColor}
          innerBorderWidth={innerBorderWidth}
          radiusLineWidth={radiusLineWidth}
          onStopSpinning={() => {
            handleSpinningStop();
            setMustSpin(false);
          }}
        />
        )}

        <div className="wheeldotsround">
          <img src={spinInnerImage} alt="spinInnerBg" className="" style={{ width: '20%' }} />
        </div>

        {/* rewardUpdateModal */}
        <CustomModal
          id={"rewardUpdateModal"}
          title={
            <>
              <div className='d-flex align-items-center '>
                {rewardWoncheck && (<h5 className="mb-0 font-bold">{t('Reward_Won')}</h5>)}
                {!rewardWoncheck && (<h5 className="mb-0 font-bold">{t('Mega_Draw_Code')}</h5>)}
                {/* <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={handleCloseModal}>
                  <img src={Close} alt="Close"
                    className="button-Close"
                  />
                </button> */}
              </div>
              <hr></hr>
            </>
          }
          content={
            <>
              <h5 className='bumperGiftsTitle mb-2' style={{ position: 'relative' }}>

                {rewardWoncheck && (t('Congratulations'))}

                <div className="">

                  {rewardWoncheck && (<div style={{ position: 'absolute', top: '-19px', left: '-9px', transform: 'rotate(90deg)' }}>
                    <img src={wired_flat} alt="wired_flat" className="img-fluid" style={{ width: '65px' }} />
                  </div>
                  )}

                  {rewardWoncheck && (<div style={{ position: 'absolute', top: '-19px', right: '-9px' }}>
                    <img src={wired_flat} alt="wired_flat" className="img-fluid" style={{ width: '65px' }} />
                  </div>
                  )}
                </div>
              </h5>

              <div className="" style={{ position: 'relative' }}>
                <img src={congratsImageUrl} alt="GiftedImg" className="img-fluid" style={{ width: '300px' }} />
                <img src={Glitter} alt="Glitter" className="img-fluid" style={{ position: 'absolute', top: '0', left: '0', width: '100%' }} />

                {couponCodeList && (
                  <p className="mb-0" style={{
                    position: 'absolute',
                    fontWeight: '900',
                    fontSize: '1.5rem',
                    color: '#005A4B',
                    top: '53%',
                    left: '50%',
                    letterSpacing: '0.5rem',
                    transform: 'translate(-50%, -50%)',
                  }} dangerouslySetInnerHTML={{ __html: couponCodeList }}>
                  </p>)}

              </div>

              <p className="mt-4" dangerouslySetInnerHTML={{ __html: primaryRewardMsg }}></p>

              {rewardWoncheck && (<p><span style={{ color: 'red' }}>*</span>Read our
                <a className="text-black" href={`${process.env.REACT_APP_API_URL_TC}${t("language")}`}><span class="text-decoration-underline text-primary">T&C</span></a> for offer details</p>)}
            </>
          }
          footer={
            <div className="d-flex w-100" style={{ gap: '4px' }}>
              {/* <div
                className="btn w-50 btn-secondary btn-rounded closBtn footerbtns-handle" onClick={handleOk}>
                {t('OK')}
              </div> */}

              <div
                className="btn w-100 btn-secondary btn-rounded closBtn footerbtns-handle" style={{zIndex:'9'}} onClick={captureAndShare}>
                {t('Share')}
              </div>

            </div>
          }
          show={rewardUpdateModal}
          onHide={() => setRewardUpdateModal(false)}
        />


        {/* <CustomModal
          id={"rewardUpdateModal"}
          title={""}
          content={
            <>
              <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
              <img src={GiftImageURL} alt="GiftImageURL" />
              <p className="congratulationsText">{t("congratulations")}</p>
              <p className="rewardText">{t("updatesOnReward")}</p>
            </>
          }
          show={rewardUpdateModal}
          onHide={() => setRewardUpdateModal(false)}
        /> */}
      </div>
    </>
  );
};

export default CustomRoulette;
